import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Form, Icon, Input, notification, Checkbox } from "antd";
import axios from "axios";

import UploadFotos from "./UploadFotos";

const { TextArea } = Input;
const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

const FormAtendimento = ({ form }) => {
    const [fileList, setFileList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = e => {
        e.preventDefault();
        form.validateFields((err, values) => {
            if (!err) {
                alterarAtendimento(values);
            }
        });
    };

    const carregarDetalhe = () => {
        axios({
            method: "get",
            url: "/api/atendimento/carregar-atendimento",
            params: {
                atendimentoId: localStorage.getItem("atendimento")
            }
        })
            .then(resp => {
                const { objetivo, estrategias, avaliacao, descricao_fotos, fotos } = resp.data;

                form.setFieldsValue({
                    objetivo: objetivo ? objetivo : "",
                    estrategia: estrategias ? estrategias : "",
                    avaliacao: avaliacao ? avaliacao : "",
                    descricao_fotos: descricao_fotos ? descricao_fotos : ""
                });

                const fotosFormatadas = fotos.map(foto => ({
                    uid: foto.id.toString(),
                    name: `foto-${foto.id}.jpg`,
                    status: "done",
                    url: foto.url,
                    id: foto.id
                }));

                setFileList(fotosFormatadas);
            })
            .catch(error => {
                try {
                    openNotificationWithIcon("error", "Erro", error.response.data);
                } catch (error) {
                    openNotificationWithIcon("error", "Erro", "Ocorreu um erro!");
                }
            });
    };

    const alterarAtendimento = registo => {
        setIsLoading(true);

        var item = new FormData();
        item.append("id", localStorage.getItem("atendimento"));
        item.append("objetivo", registo.objetivo);
        item.append("estrategia", registo.estrategia);
        item.append("avaliacao", registo.avaliacao);
        item.append("descricaoFotos", registo.descricao_fotos);

        const fotosExistentes = fileList.filter(f => f.id); // Fotos que já existem na BD
        fotosExistentes.forEach(foto => {
            item.append("fotosExistentesIds", foto.id);
        });

        const fotosNovas = fileList.filter(f => !f.id);
        fotosNovas.forEach(file => {
            item.append("fotos", file.originFileObj || file);
        });

        axios({
            method: "put",
            url: "/api/atendimento/alterar-atendimento",
            data: item
        })
            .then(() => {
                openNotificationWithIcon("success", "Atendimento salvo", "O registo foi atualizado com sucesso.");
            })
            .catch(error => {
                try {
                    openNotificationWithIcon("error", "Erro", error.response.data);
                } catch (error) {
                    openNotificationWithIcon("error", "Erro", "Ocorreu um erro!");
                }
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    useEffect(() => {
        carregarDetalhe();
    }, []);

    const { getFieldDecorator } = form;

    return (
        <Form className="form-categorias" layout="horizontal" onSubmit={handleSubmit}>
            <div className="bloco">
                <Form.Item label="OBJETIVO DO ATENDIMENTO">
                    {getFieldDecorator("objetivo")(
                        <TextArea name="objetivo" placeholder="Descreva o objetivo do atendimento..." rows={4} style={{ height: 100 }} />
                    )}
                </Form.Item>
                <Form.Item label="ESTRATÉGIAS PEDAGÓGICAS">
                    {getFieldDecorator("estrategia")(
                        <TextArea name="estrategia" placeholder="Descreva as estratégias utilizadas..." rows={4} style={{ height: 100 }} />
                    )}
                </Form.Item>
                <Form.Item label="AVALIAÇÃO">
                    {getFieldDecorator("avaliacao")(
                        <TextArea name="avaliacao" placeholder="Avalie o atendimento realizado..." rows={4} style={{ height: 100 }} />
                    )}
                </Form.Item>
                <Form.Item
                    label={
                        <div>
                            <div style={{ fontWeight: "bold", fontSize: 14 }}>REGISTROS DE FOTOS:</div>
                            <div style={{ fontWeight: 400, fontSize: 12, color: "#8c8c8c", lineHeight: "normal" }}>
                                Opção para adicionar até 3 fotos e anexar ao relatório de atendimento
                            </div>
                        </div>
                    }
                >
                    <UploadFotos fileList={fileList} setFileList={setFileList} />
                </Form.Item>
                <Form.Item>
                    {getFieldDecorator("descricao_fotos")(
                        <TextArea
                            name="descricao_fotos"
                            placeholder="Adicione informações sobre as fotos..."
                            rows={4}
                            style={{ height: 100 }}
                        />
                    )}
                </Form.Item>
            </div>
            <button className="botao-principal">
                {isLoading ? <Icon type="loading" /> : null}
                Salvar
            </button>
        </Form>
    );
};

export default Form.create({ name: "form-atendimento" })(FormAtendimento);
